import {resetFilterValues} from "./utils/filterUtils";
import {initCarousels} from "./utils/carousel";

resetFilterValues();

$(function() {
    //not used probably?
    //initCarousels();

    $(".home-carousel").each(function() {
        const carousel = $(this);
        const track = carousel.find(".home-carousel__track");
        const prevControl = carousel.find(".home-carousel__control--prev");
        const nextControl = carousel.find(".home-carousel__control--next");

        function updateControls() {
            const scrollLeft = track.scrollLeft();
            const maxScrollLeft = track[0].scrollWidth - track[0].clientWidth;

            prevControl.toggle(scrollLeft > 1);
            nextControl.toggle(scrollLeft < maxScrollLeft - 1);
        }

        updateControls();

        track.on("scroll", updateControls);
        $(window).on("resize load", updateControls);

        prevControl.click(function() {
            scrollCarousel(track, -1);
        });

        nextControl.click(function() {
            scrollCarousel(track, 1);
        });
    });

    $(".btn-less-features").click(function(e) {
        e.preventDefault();

        const grid = $(this).closest(".container").find(".feature-grid-content");
        const btnMore = $(".btn-more-features");

        grid.removeClass("expanded");

        btnMore.find("span").html(btnMore.data("show-more"));

        $(this).hide();
    });

    $(".btn-more-features").click(function(e) {
        e.preventDefault();

        const grid = $(this).closest(".container").find(".feature-grid-content");

        if(grid.hasClass("expanded")) {
            window.location.href = $(this).attr("href");
        } else {
            grid.addClass("expanded");
            $(this).find("span").html($(this).data("show-all"));
            $(".btn-less-features").show();
        }
    });

    //Sliders
    let defaultInterval = 4500;
    let fadeout = 1500;

    $(".slider").each(function() {
        let slider = $(this);
        let fixed = slider.data("fixed-height");

        if(!fixed) {
            //TODO find an event based way, because if the images are lazy loaded, it does not work correctly
            computeSliderHeight(slider);

            $(window).on("load", function() {
                computeSliderHeight(slider)
            })
        }

        let intervalData = parseInt(slider.data("interval"));
        let interval;

        if(intervalData > 0) {
            interval = intervalData * 1000;
        } else {
            interval = defaultInterval;
        }

        setInterval(function() {
            if(!slider.is(":visible")) { //skip hidden
                return;
            }

            let activeItem = slider.find(".slider-item.slider-item--active");
            let nextActiveItem = activeItem.next();
            if(!nextActiveItem.length) {
                nextActiveItem = slider.find(".slider-item:first");
            }

            activeItem.removeClass("slider-item--active");

            nextActiveItem.addClass("slider-item--front");
            nextActiveItem.addClass("slider-item--active");

            setTimeout(function (slider) {
                activeItem.removeClass("slider-item--front");
            }, fadeout)
        }, interval);
    });
});

function scrollCarousel(track, direction) {
    const card = track.find(".home-carousel-card").first();
    const step = (card.outerWidth() + 16) * 2 * direction; // card width + gap, two cards per click

    track[0].scrollBy({
        left: step,
        behavior: "smooth"
    });
}

function computeSliderHeight(slider) {
    let height = 0;
    slider.find(".slider-item").each(function() {
        let thisHeight = $(this).outerHeight();
        if(thisHeight > height) {
            height = thisHeight;
        }
        $(this).css("position", "absolute");
    })

    if(height < 105) {
        height = 105; //minimal height;
    }

    slider.css("height", height + "px");
    //console.log(height);
}